export default "__VITE_ASSET__DmF8xT02__"